var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "property_container pa-0 pb-3 rounded-lg",
      attrs: { fluid: "" },
    },
    [
      _vm.items_copy.length == 0
        ? _c("noContent")
        : _c(
            "a-table",
            {
              attrs: {
                columns: _vm.headers,
                pagination: false,
                loading: _vm.isLoading,
                childrenColumnName: "children",
                showHeader: false,
                rowKey: "property_master_code",
                expandIcon: function (props) {
                  return _vm.customExpandIcon(props)
                },
                size: "small",
                "data-source": _vm.items_copy,
                rowClassName: function (record, index) {
                  return _vm.getCurEdit2(record, _vm.listdata)
                    ? ""
                    : "grey lighten-4"
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "name",
                    fn: function (text, record, index) {
                      return [
                        _vm._t("name", function () {
                          return [
                            _c(
                              "span",
                              {
                                style: {
                                  color: _vm.getCurEdit2(record, _vm.listdata)
                                    ? "rgba(0,0,0,0.87)"
                                    : "rgba(0,0,0,0.38)",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        record.property_master_name
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        }),
                      ]
                    },
                  },
                  {
                    key: "value",
                    fn: function (text, record, index) {
                      return [
                        _c(
                          "div",
                          [
                            _vm._t("value", function () {
                              return [
                                record.changeList.length
                                  ? [
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getTrueValue(
                                                record.changeList,
                                                record.data_type,
                                                record.prompt_name,
                                                record
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  : [
                                      record.prompt_name !== "" &&
                                      record.prompt_name !== null &&
                                      record.prompt_name !== undefined
                                        ? _c("span", [
                                            _vm.promptArr.indexOf(
                                              record.prompt_name
                                            ) != -1
                                              ? _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("getPrompt")(
                                                          record.value,
                                                          record,
                                                          _vm.getPromptValue
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : (record.value === null
                                                  ? ""
                                                  : record.value
                                                ).toString() == "1" ||
                                                (record.value === null
                                                  ? ""
                                                  : record.value
                                                ).toString() == "0"
                                              ? _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        (record.value === null
                                                          ? ""
                                                          : record.value
                                                        ).toString() == "1"
                                                          ? _vm.$t(
                                                              "label_essweb_system_label_trueLabel"
                                                            )
                                                          : (record.value ===
                                                            null
                                                              ? ""
                                                              : record.value
                                                            ).toString() == "0"
                                                          ? _vm.$t(
                                                              "label_essweb_system_label_falseLabel"
                                                            )
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v(_vm._s(record.value)),
                                                ]),
                                          ])
                                        : record.data_type === "boolean"
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  (record.value === null
                                                    ? ""
                                                    : record.value
                                                  ).toString() == "1"
                                                    ? _vm.$t(
                                                        "label_essweb_system_label_trueLabel"
                                                      )
                                                    : (record.value === null
                                                        ? ""
                                                        : record.value
                                                      ).toString() == "0"
                                                    ? _vm.$t(
                                                        "label_essweb_system_label_falseLabel"
                                                      )
                                                    : record.value
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : record.data_type === "int" ||
                                          record.data_type === "String" ||
                                          record.data_type === "bigint"
                                        ? _c("span", [
                                            _vm._v(
                                              " " + _vm._s(record.value) + " "
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(_vm._s(record.value)),
                                          ]),
                                    ],
                              ]
                            }),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                  {
                    key: "action",
                    fn: function (text, record, index) {
                      return !_vm.onlyShow
                        ? [
                            _vm.canEdit
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      disabled: _vm._f("CurEdit")(
                                        record,
                                        _vm.listdata,
                                        _vm.getCurEdit2
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toEdit(record)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("edit")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            !_vm.canEdit && _vm.canView
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      disabled: _vm._f("CurEdit")(
                                        record,
                                        _vm.listdata,
                                        _vm.getCurEdit2
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toView(record)
                                      },
                                    },
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        size: "24",
                                        fill: "currentColor",
                                        iconClass: "viewDetail",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : undefined
                    },
                  },
                ],
                null,
                true
              ),
            },
            [_c("template", { slot: "footer" })],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }